import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { isNil } from "ramda";

export const useToFormOnEmpty: (data: unknown, to?: string) => void = (data, to = "..") => {
  const navigate = useNavigate();
  useEffect(() => {
    if (isNil(data)) {
      navigate(to, { replace: true });
    }
  }, [data, navigate, to]);
};
